import { TypedNode } from "@game/engine/navigation/Pathfinder";

export default class PathfindingAlgorithm {
  // IMPORTANT Don't use this for comparing nodes from different graphs
  public equals(nodeA: TypedNode, nodeB: TypedNode): boolean {
    return nodeA.index === nodeB.index;
  }
}
